import {Avatar, Input, message, Modal, Radio, Tabs} from 'antd'
import {getId} from 'apis/model/base'
import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {Formik} from 'formik'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParam,} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderIf} from 'views/Shared'
import {
    course_class_student_subject_editResult_Api,
    course_getCourseSubjectsByCourseStudent_Api,
    course_getSubjectResultsByCourseClassStudent_Api,
    course_student_subject_createResult_Api,
    course_updateResultStatus_Api
} from "../../../../apis";
import {renderSubjectResultItem} from "../../../Workspace/Course/functions/renderSubjectResultItem";
import {renderCourseClassStudentSubjectSummary} from "../../../Workspace/Course/functions/renderCourseClassStudentSubjectSummary";
import {bindQueryParams} from "../../functions/routerHelper";
import {renderElse, renderIfElse} from "../../../Shared";
import _ from "lodash"
import {createControlledFormField} from "../../factory/createFormField";
import classNames from "classnames";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {notifyOnError} from "../../factory/createErrorEvent";
import Translate from "../../../../modules/local/Translate";
import {renderEmptyHolder} from "../../../../components/EmptyHolder";
import {attendance_status_options} from "../index";
import {RxCheckCircled, RxPencil2, RxPlusCircled} from "react-icons/rx";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {createValue} from "../../../../components/form/utils";
import {compose, mapProps} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {CustomToggleField} from "../../../../components/form/fields/ToggleField";
import {BsCalendar2Check, BsInfoCircleFill} from "react-icons/bs";
import TooltipApp from "components/TooltipApp";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {GoDotFill} from "react-icons/go";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getAvatar from "../../../../helpers/getAvatar";
import copyToClipboard from "copy-to-clipboard";
import {IoCopyOutline} from "react-icons/io5";
import {FaUserGraduate} from "react-icons/fa6";
import {renderEmptyHolderMember} from "../../CatholicHousehold/functions/renderEmptyHolderMember";
import getAliasName from "../../../../helpers/getAliasName";
import {IoMdAnalytics} from "react-icons/io";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {ItemInformation} from "../../../../components/common/ItemInformation";


export const formSchema = {
    result_status: {
        // title: 'subject result status',
        children: [
            {
                name: 'result_status',
                component: ({name, value, form, onChange}) => {
                    const options = [
                        {prefixCls: 'not-assessed', label: 'pending', value: -1, className: 'text-blue-700'},
                        {prefixCls: 'fail-course', label: 'failed', value: 0, className: 'text-primary-800'},
                        {prefixCls: 'pass-course', label: 'passed', value: 1, className: 'text-green-700'},
                    ]
                    return (
                        <Translate>
                            {(t) => (
                                <div className="flex items-center mt-1 mb-2">
                                    <Radio.Group
                                        optionType="button"
                                        buttonStyle="solid"
                                        className="w-full grid grid-col-1 md:grid-cols-3 gap-3 custom-radio-exam-results"
                                        name={name}
                                        value={value}
                                        onChange={(event) => {
                                            onChange(createValue(name, event.target.value ?? undefined))
                                        }}>
                                        {options.map((e, i) => {
                                            return (
                                                <Radio.Button key={i} value={e.value} prefixCls={e.prefixCls}
                                                              style={{padding: '6px 10px'}}>
                            <span className={classNames("font-bold text-base leading-snug", e.className)}>
                              {t(e.label)}
                            </span>
                                                </Radio.Button>
                                            )
                                        })}
                                    </Radio.Group>
                                </div>
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    eligibility_status: {
        children: [
            {
                name: 'eligibility_status',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value: Number(value) === 1,
                        onChange: (value) => {
                            onChange(createValue(name, Boolean(value) ? 1 : 0))
                        },
                        className: "ml-0 md:ml-3 my-2",
                        title: translate('eligibility for exam'),
                        description: 'eligibility for exam description',
                        Icon: BsCalendar2Check,
                        size: 'small',
                    }))
                )(CustomToggleField),
            }
        ],
    },
    notes: {
        title: 'notes',
        children: [
            {
                name: 'notes',
                component: createControlledFormField({
                    placeholder: 'notes',
                    className: 'scrollBarThin',
                    Component: Input.TextArea,
                    autoSize: {minRows: 2, maxRows: 4},
                }),
            },
        ],
    },
}

const SubjectSummaryCreateForm = ({
                                      subject,
                                      summary_info,
                                      onCancel = NullAsDefault,
                                      onSubmit = NullAsDefault,
                                      ...props
                                  }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        const {result_status} = values ?? {}
        // if (result_status === null) {
        //   errors.result_status = t('required field')
        // }
        return errors
    }

    const initialValues = useMemo(() => {
        return {
            result_status: -1,
            eligibility_status: 0,
        }
    }, [])

    const {description} = subject ?? {}
    const {attendance_details = [], grade_details = [], total_sessions, number_of_sessions, passed_attendance_status, avg_score, passed_score_status} = summary_info ?? {}

    const percent = ((total_sessions / number_of_sessions) * 100).toFixed(2)

    let attend_label_status, score_label_status
    let attend_color_status, score_color_status

    switch (passed_attendance_status) {
        case 1:
            attend_label_status = 'passed'
            attend_color_status = 'text-green-700'
            break
        case 0:
            attend_label_status = 'failed'
            attend_color_status = 'text-red-600'
            break
        default:
            attend_label_status = 'pending'
            attend_color_status = 'text-color-300'
            break
    }

    switch (passed_score_status) {
        case 1:
            score_label_status = 'passed'
            score_color_status = 'text-green-700'
            break
        case 0:
            score_label_status = 'failed'
            score_color_status = 'text-red-600'
            break
        default:
            score_label_status = 'pending'
            score_color_status = 'text-color-300'
            break
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {...rest} = values ?? {}
                onSubmit(rest)
            }}>
            <React.Fragment>
                <ActionModalWrapper action={<FormActionGroups submitProps={{label: 'submit'}}/>}>

                    <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                            <IoMdAnalytics size={16} className="text-blue-400 mr-1"/>
                            <div
                                className="flex-1 font-bold text-sm text-blue-700 uppercase tracking-wide leading-tight">
                                {t('subject result status')}
                            </div>
                        </div>
                        <span className="ml-1 mb-1 text-xs text-color-400 italic">
                {`* ${t('result status subject description')}`}
              </span>
                        <FieldsFactory formSchema={[formSchema.result_status]}/>
                        <ItemInformation primary={true} showIcon={true} label="subject name" value={getTitle(subject)}
                                         className="text-xs"/>
                        <ItemInformation showIcon={true} label="number of sessions"
                                         value={`${number_of_sessions} ${t('sessions')}`} className="text-xs italic"/>
                    </div>

                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                                <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                                <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                  {t('attendance information')}
                </span>
                                <span className="font-bold text-2xs md:text-xs text-color-100 leading-tight italic">
                  {`( ${total_sessions}/${number_of_sessions || 0} - ${percent}% )`}
                </span>
                                <span
                                    className={classNames("font-bold text-2xs md:text-xs tracking-wide uppercase opacity-80", attend_color_status)}>
                    {t(attend_label_status)}
                </span>
                            </div>
                            <FieldsFactory formSchema={[formSchema.eligibility_status]}/>
                            <div className="ml-0 md:ml-2 flex flex-col gap-1">
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={13} className="text-color-500"/>
                                    <span className="text-sm text-color-400 italic whitespace-nowrap">
                    {`${t('course details')} : `}
                  </span>
                                </div>
                                {renderIfElse(
                                    attendance_details.length,
                                    <div className="flex flex-col gap-2 ml-2">
                                        {attendance_details.map((e, i) => {
                                            const status_options = Object.values(attendance_status_options)
                                            const current_status = _.find(status_options, {value: e.status}) ?? {}
                                            return (
                                                <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                          <span className="flex-1 font-bold text-xs text-color-100 italic">
                              {`${i + 1}. ${getTitle(e.attendance)}`}
                          </span>
                                                    <div className="flex items-center gap-x-6">
                            <span className="text-xs italic">
                                <span className="text-color-500">{`${t('attendances')} : `}</span>
                                <span className={current_status.className}>{t(current_status.label)}</span>
                            </span>
                                                        <span className="text-xs italic">
                                <span className="text-color-500">{`${t('number sessions')} : `}</span>
                                <span className="font-medium text-color-100">{e.number_of_sessions}</span>
                            </span>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>,
                                    renderEmptyHolderMember("no data is available now", 'subject complete description')
                                )}
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <div className="flex items-center gap-2">
                                <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                                <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                  {t('academic information')}
                </span>
                                <span
                                    className="font-bold text-2xs md:text-xs text-color-100 capitalize leading-tight italic">
                  {`( ${t('avg point')} : ${avg_score || 0} )`}
                </span>
                                <span
                                    className={classNames("font-bold text-2xs md:text-xs tracking-wide uppercase opacity-80", score_color_status)}>
                    {t(score_label_status)}
                </span>
                            </div>
                            <div className="ml-0 md:ml-2 flex flex-col gap-1">
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={13} className="text-color-500"/>
                                    <span className="text-sm text-color-400 italic whitespace-nowrap">
                    {`${t('course details')} : `}
                  </span>
                                </div>
                                {renderIfElse(
                                    grade_details.length,
                                    <div className="flex flex-col gap-2 ml-2">
                                        {grade_details.map((e, i) => {
                                            const {grade, score_type, score_number, score_text, score_1_number, score_1_text, score_2_number, score_2_text, score_weight} = e ?? {}
                                            return (
                                                <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                            <span className="flex-1 font-bold text-xs text-color-100 italic">
                                {`${i + 1}. ${getTitle(grade)}`}
                            </span>
                                                    <TooltipApp
                                                        title={<span>{`${t('score weight')} : ${score_weight}`}</span>}
                                                        placement="left"
                                                        style={{
                                                            body: {
                                                                minHeight: 28,
                                                                padding: '4px 8px',
                                                                fontSize: 12,
                                                                fontStyle: 'italic',
                                                            }
                                                        }}>
                                                        <div className="flex items-center gap-x-6">
                                    <span
                                        className={classNames("text-xs italic", (!!(score_1_number || score_1_text) && "text-line-through"))}>
                                        <span className="text-color-500">{`${t('score times')} 1 : `}</span>
                                        <span className="font-medium text-color-100">
                                            {renderIfElse(score_type === 'text', score_text, score_number)}
                                        </span>
                                        {
                                            renderIf(
                                                !!score_weight && score_weight !== 1 && score_type !== 'text',
                                                <span className="font-normal text-xs text-color-200 px-1">
                                                (x {renderElse(score_type === 'text', score_weight)})
                                            </span>
                                            )
                                        }
                                    </span>
                                                            {renderIf(
                                                                score_1_number || score_1_text,
                                                                <span
                                                                    className={classNames("text-xs italic", (!!(score_2_number || score_2_text) && "text-line-through"))}>
                                            <span className="text-color-500">{`${t('score times')} 2 : `}</span>
                                            <span className="font-medium text-color-100">
                                                {renderIfElse(score_type === 'text', score_1_text, score_1_number)}
                                            </span>
                                                                    {
                                                                        renderIf(
                                                                            !!score_weight && score_weight !== 1 && score_type !== 'text',
                                                                            <span
                                                                                className="font-normal text-xs text-color-200 px-1">
                                                (x {renderElse(score_type === 'text', score_weight)})
                                            </span>
                                                                        )
                                                                    }
                                        </span>
                                                            )}
                                                            {renderIf(
                                                                score_2_number || score_2_text,
                                                                <span className="text-xs italic">
                                <span className="text-color-500">{`${t('score times')} 3 : `}</span>
                                <span className="font-medium text-color-100">
                                    {renderIfElse(
                                        score_type === 'text',
                                        score_2_text,
                                        score_2_number
                                    )}
                                </span>
                                                                    {
                                                                        renderIf(
                                                                            !!score_weight && score_weight !== 1 && score_type !== 'text',
                                                                            <span
                                                                                className="font-normal text-xs text-color-200 px-1">
                                                (x {renderElse(score_type === 'text', score_weight)})
                                            </span>
                                                                        )
                                                                    }
                            </span>
                                                            )}
                                                        </div>
                                                    </TooltipApp>
                                                </div>
                                            )
                                        })}
                                    </div>,
                                    renderEmptyHolderMember("no data is available now", 'subject complete description')
                                )}
                            </div>
                        </div>
                    </div>

                    <FieldsFactory formSchema={[formSchema.notes]}/>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )
}

const SubjectSummaryEditForm = ({
                                    subject,
                                    summary_info,
                                    onCancel = NullAsDefault,
                                    onSubmit = NullAsDefault,
                                }) => {
    const t = useTranslate()

    const validate = (values) => {
        let errors = {}
        const {result_status} = values ?? {}
        // if (result_status === null) {
        //   errors.result_status = t('required field')
        // }
        return errors
    }

    const _initialValues = useMemo(() => {
        const {...rest} = summary_info ?? {}
        return {
            ...rest,
        }
    }, [summary_info])

    const {attendance_details = [], grade_details = [], total_sessions, number_of_sessions, passed_attendance_status, avg_score, passed_score_status} = summary_info ?? {}

    const percent = ((total_sessions / number_of_sessions) * 100).toFixed(2)

    let attend_label_status, score_label_status
    let attend_color_status, score_color_status

    switch (passed_attendance_status) {
        case 1:
            attend_label_status = 'passed'
            attend_color_status = 'text-green-700'
            break
        case 0:
            attend_label_status = 'failed'
            attend_color_status = 'text-red-600'
            break
        default:
            attend_label_status = 'pending'
            attend_color_status = 'text-color-300'
            break
    }

    switch (passed_score_status) {
        case 1:
            score_label_status = 'passed'
            score_color_status = 'text-green-700'
            break
        case 0:
            score_label_status = 'failed'
            score_color_status = 'text-red-600'
            break
        default:
            score_label_status = 'pending'
            score_color_status = 'text-color-300'
            break
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {result_status, eligibility_status, ...rest} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            result_status: result_status ?? null,
                            eligibility_status: eligibility_status ?? null
                        },
                        _.isUndefined
                    )
                )
            }}
            enableReinitialize={true}>
            <React.Fragment>
                <ActionModalWrapper action={<FormActionGroups submitProps={{label: 'save'}}/>}>
                    <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                            <IoMdAnalytics size={16} className="text-blue-400 mr-1"/>
                            <div
                                className="flex-1 font-bold text-sm text-blue-700 uppercase tracking-wide leading-tight">
                                {t('subject result status')}
                            </div>
                        </div>
                        <span className="ml-1 mb-1 text-xs text-color-400 italic">
                {`* ${t('result status subject description')}`}
              </span>
                        <FieldsFactory formSchema={[formSchema.result_status]}/>
                        <ItemInformation primary={true} showIcon={true} label="subject name" value={getTitle(subject)}
                                         className="text-xs"/>
                        <ItemInformation showIcon={true} label="number of sessions"
                                         value={`${number_of_sessions} ${t('sessions')}`} className="text-xs italic"/>
                    </div>

                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col">
                            <div className="flex items-center gap-2 3">
                                <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                                <span
                                    className="font-bold text-sm text-color-400 uppercase tracking-wider">{t('attendance information')}</span>
                                <span className="font-bold text-2xs md:text-xs text-color-100 leading-tight italic">
                    {`( ${total_sessions}/${number_of_sessions} - ${percent}% )`}
                  </span>
                                <span
                                    className={classNames("ml-3 font-bold text-2xs md:text-xs tracking-wide uppercase opacity-80", attend_color_status)}>
                    {t(attend_label_status)}
                  </span>
                            </div>
                            <FieldsFactory formSchema={[formSchema.eligibility_status]}/>
                            <div className="ml-0 md:ml-2 flex flex-col gap-1">
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={13} className="text-color-500"/>
                                    <span className="text-sm text-color-400 italic whitespace-nowrap">
                      {`${t('course details')} : `}
                    </span>
                                </div>
                                {renderIfElse(
                                    attendance_details.length,
                                    <div className="ml-1 md:ml-2 flex flex-col gap-3">
                                        {attendance_details.map((e, i) => {
                                            const status_options = Object.values(attendance_status_options)
                                            const current_status = _.find(status_options, {value: e.status}) ?? {}
                                            return (
                                                <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                                <span className="flex-1 font-bold text-xs text-color-100 italic">
                                  {`${i + 1}. ${getTitle(e.attendance)}`}
                                </span>
                                                    <div className="flex items-center gap-x-6">
                                                        <ItemInformation
                                                            showIcon={true}
                                                            label="attendances"
                                                            value={
                                                                <span
                                                                    className={current_status.className}>{t(current_status.label)}</span>
                                                            }
                                                            className="text-xs italic"
                                                        />
                                                        <ItemInformation
                                                            showIcon={true}
                                                            label="total sessions"
                                                            value={e.number_of_sessions}
                                                            className="text-xs italic"
                                                        />
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>,
                                    renderEmptyHolderMember("no data is available now", 'subject complete description')
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col">
                            <div className="flex items-center gap-2 4">
                                <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                                <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                    {t('academic information')}
                  </span>
                                <span
                                    className="font-bold text-2xs md:text-xs text-color-100 capitalize leading-tight italic">
                    {`( ${t('avg point')} : ${avg_score || 0} )`}
                  </span>
                                <span
                                    className={classNames("ml-3 font-bold text-2xs md:text-xs tracking-wide uppercase opacity-80", score_color_status)}>
                    {t(score_label_status)}
                  </span>
                            </div>
                            <div className="ml-0 md:ml-2 flex flex-col gap-2">
                                <div className="flex items-center gap-3">
                                    <GoDotFill size={13} className="text-color-500"/>
                                    <span className="text-sm text-color-400 italic whitespace-nowrap">
                      {`${t('course details')} : `}
                    </span>
                                </div>
                                {renderIfElse(
                                    grade_details.length,
                                    <div className="ml-1 md:ml-2 flex flex-col gap-3">
                                        {grade_details.map((e, i) => {
                                            const {grade, score_type, score_number, score_text, score_1_number, score_1_text, score_2_number, score_2_text, score_weight} = e ?? {}
                                            return (
                                                <div key={i} className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
                                <span className="font-bold text-xs text-color-100 italic">
                                  {`${i + 1}. ${getTitle(grade)}`}
                                </span>
                                                    <TooltipApp
                                                        title={<span>{`${t('score weight')} : ${score_weight}`}</span>}
                                                        placement="left"
                                                        style={{
                                                            body: {
                                                                minHeight: 28,
                                                                padding: '4px 8px',
                                                                fontSize: 12,
                                                                fontStyle: 'italic',
                                                            }
                                                        }}>
                                                        <div className="flex items-center gap-x-4">
                                    <span
                                        className={classNames("text-xs italic", (!!(score_1_number || score_1_text) && "text-line-through opacity-50"))}>
                                      <GoDotFill size={10} className="text-color-500 mr-1"/>
                                      <span className="text-color-500">{`${t('score times')} 1 : `}</span>
                                      <span className="font-bold text-color-100 hover:text-color-000 cursor-pointer">
                                        {renderIfElse(score_type === 'text', score_text, score_number)}
                                      </span>
                                        {renderIf(
                                            !!score_weight && score_weight !== 1 && score_type !== 'text',
                                            <span className="font-normal text-xs text-color-200 px-1">
                                            (x {renderElse(score_type === 'text', score_weight)})
                                          </span>
                                        )}
                                    </span>
                                                            {renderIf(
                                                                score_1_number || score_1_text,
                                                                <span
                                                                    className={classNames("text-xs italic", (!!(score_2_number || score_2_text) && "text-line-through opacity-50"))}>
                                          <GoDotFill size={10} className="text-color-500 mr-1"/>
                                          <span className="text-color-500">{`${t('score times')} 2 : `}</span>
                                          <span className="font-bold text-color-100">
                                            {renderIfElse(score_type === 'text', score_1_text, score_1_number)}
                                          </span>
                                                                    {renderIf(
                                                                        !!score_weight && score_weight !== 1 && score_type !== 'text',
                                                                        <span
                                                                            className="font-normal text-xs text-color-200 px-1">
                                                (x {renderElse(score_type === 'text', score_weight)})
                                              </span>
                                                                    )}
                                        </span>
                                                            )}
                                                            {renderIf(
                                                                score_2_number || score_2_text,
                                                                <span className="text-xs italic">
                                          <GoDotFill size={10} className="text-color-500 mr-1"/>
                                          <span className="text-color-500">{`${t('score times')} 3 : `}</span>
                                          <span className="font-bold text-color-100">
                                            {renderIfElse(score_type === 'text', score_2_text, score_2_number)}
                                          </span>
                                                                    {renderIf(
                                                                        !!score_weight && score_weight !== 1 && score_type !== 'text',
                                                                        <span
                                                                            className="font-normal text-xs text-color-200 px-1">
                                                (x {renderElse(score_type === 'text', score_weight)})
                                              </span>
                                                                    )}
                                        </span>
                                                            )}
                                                        </div>
                                                    </TooltipApp>
                                                </div>
                                            )
                                        })}
                                    </div>,
                                    renderEmptyHolderMember("no data is available now", 'subject complete description')
                                )}
                            </div>
                        </div>
                    </div>

                    <FieldsFactory formSchema={[formSchema.notes]}/>
                </ActionModalWrapper>
            </React.Fragment>
        </Formik>
    )

}

const CourseStudentSubjectResults = ({
                                         student,
                                         course,
                                         course_student,
                                     }) => {
    const t = useTranslate()

    const {isSm} = useContext(LayoutContext)

    const [current, setCurrent] = useState('0')

    const {edit} = course ?? {}

    const student_id = getId(student)

    const course_id = getId(course)

    const course_student_id = getId(course_student)

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const apiInfo = course_getCourseSubjectsByCourseStudent_Api
    const [refreshKey, setRefreshKey] = useState(
        [
            apiInfo?.path
                ?.replace(':student_id', student?.id)
                ?.replace(':course_id', course?.id),
        ].join('/')
    )

    const apiInfo1 = course_getSubjectResultsByCourseClassStudent_Api
    const refreshKey1 = useMemo(
        () =>
            [apiInfo1.path.replace(':student_id', student?.id), course?.id].join(
                '/'
            ),
        [student, course]
    )

    const onError = notifyOnError(t)

    const reload = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: course_student_subject_createResult_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: course_class_student_subject_editResult_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onResultUpdate} = useAsyncAction({
        apiInfo: course_updateResultStatus_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const onCancel = () => {
        setAction({})
    }

    const modal = useMemo(() => {
        const {id, subject, course_class, student} = action?.value ?? {}
        let title
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {}
        let modal_params = {}
        switch (action?.type) {
            case 'SUBJECT_SUMMARY_CREATE':
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('subject result status')}
                    </div>
                )
                params = {
                    summary_info: action?.value,
                    subject,
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values, {
                            course_id: course?.id,
                            student_id: student?.id,
                            subject_id: subject?.id,
                        })
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = SubjectSummaryCreateForm
                break
            case 'SUBJECT_SUMMARY_UPDATE':
                title = (
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('edit subject result status')}
                    </div>
                )
                params = {
                    summary_info: action?.value,
                    subject,
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                modal_params = {
                    width: 640,
                }
                Content = SubjectSummaryEditForm
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({isLoading, initialValues}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                initialValues={initialValues}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [course, student, action])

    const renderActions = useCallback(
        (item) => {

            let label_status
            let color_status
            switch (item?.result_status) {
                case 1:
                    label_status = 'passed'
                    color_status = 'text-green-700'
                    break
                case 0:
                    label_status = 'failed'
                    color_status = 'text-red-600'
                    break
                case -1:
                    label_status = 'pending'
                    color_status = 'text-color-300'
                    break
                default:
                    label_status = 'evaluate'
                    color_status = 'text-color-300'
                    break
            }

            return (
                renderIfElse(
                    item?.result_status === null,
                    <span
                        onClick={() => {
                            setAction({type: 'SUBJECT_SUMMARY_CREATE', value: item})
                        }}
                        className={
                            classNames("flex items-center opacity-70 hover:opacity-100 hover:underline", color_status)
                        }>
                  <RxPlusCircled size={13} className="mr-2"/>
                  <span className="font-bold text-xs tracking-wide uppercase cursor-pointer">
                    {t(label_status)}
                  </span>
                </span>,
                    <TooltipApp
                        title={t('edit')}
                        placement="left"
                        style={{
                            body: {
                                minHeight: 26,
                                fontSize: 11,
                                fontStyle: 'italic',
                            }
                        }}>
                <span
                    onClick={() => {
                        setAction({type: 'SUBJECT_SUMMARY_UPDATE', value: item})
                    }}
                    className={
                        classNames("flex items-center opacity-70 hover:opacity-100 hover:underline", color_status)
                    }>
                  <RxPencil2 size={13} className="mr-2"/>
                  <span className="font-bold text-xs tracking-wide uppercase cursor-pointer">
                    {t(label_status)}
                  </span>
                </span>
                    </TooltipApp>
                )
            )
        },
        []
    )

    const {patron_saint_name, prefix_title, fullname, student_idcode, user} = student ?? {}
    const {registered_classes = [], registered_subjects = []} = course_student ?? {}

    return (
        <div className="flex flex-col space-y-6 relative">
            <div style={{bottom: isSm && 0}} className="flex flex-col stickyBottom background">
                <div className="flex items-center gap-2">
                    <IoMdAnalytics size={18} className="text-blue-400"/>
                    <span className="font-bold text-sm md:text-base text-blue-600 uppercase tracking-wide">
              {t('evaluate the final exam results of students')}
            </span>
                </div>
                <div className="mb-3 text-xs text-color-400 italic">
                    {`* ${t('evaluate the final exam results of students description')}`}
                </div>
                <Radio.Group
                    name="result_status"
                    className="w-full grid grid-col-1 md:grid-cols-3 gap-3 mb-3 custom-radio-exam-results"
                    optionType="button"
                    buttonStyle="solid"
                    onChange={(event) => {
                        const {name, value} = event.target
                        Modal.confirm({
                            icon: null,
                            title: (
                                <div className="flex items-center gap-2 font-semibold text-green-700">
                                    <RxCheckCircled size={20} className="anticon"/>
                                    {t('student assessment')}
                                </div>
                            ),
                            content: (
                                <div className="text-sm italic text-color-300">
                                    {t('are you sure you want to assess this student')}
                                </div>
                            ),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                className: 'button-rounded-md no-border',
                                type: 'primary',
                            },
                            cancelButtonProps: {
                                className: 'button-rounded-md no-border',
                            },
                            onOk: () => {
                                onResultUpdate({result_status: value}, {id: course_student_id})
                            },
                        })
                    }}
                    defaultValue={course_student?.result_status ?? undefined}>
                    <Radio.Button value={undefined} prefixCls="not-assessed">
                        <div className="flex flex-col items-center gap-1">
                            <span
                                className="font-bold text-base text-blue-700 leading-snug">{t('not assessed yet')}</span>
                            <span
                                className="text-center font-normal text-xs italic tracking-wide leading-tight">{t('not assessed description')}</span>
                        </div>
                    </Radio.Button>
                    <Radio.Button value={0} prefixCls="fail-course">
                        <div className="flex flex-col items-center gap-1">
                            <span className="font-bold text-base text-primary-800 leading-snug">{t('failed')}</span>
                            <span
                                className="text-center font-normal text-xs italic tracking-wide leading-tight">{t('failed course description')}</span>
                        </div>
                    </Radio.Button>
                    <Radio.Button value={1} prefixCls="pass-course">
                        <div className="flex flex-col items-center gap-1">
                            <span className="font-bold text-base text-green-700 leading-snug">{t('passed')}</span>
                            <span
                                className="text-center font-normal text-xs italic tracking-wide leading-tight">{t('complete course description')}</span>
                        </div>
                    </Radio.Button>
                </Radio.Group>
            </div>

            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    renderTitle={() => (
                        <div className="flex items-center gap-2">
                            <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                            <span className="font-bold text-sm text-color-300 uppercase tracking-wider">
                      {t('student information')}
                    </span>
                        </div>
                    )}
                />
                <div className="flex flex-col gap-1">
                    <div className="flex items-center gap-2 mb-1">
                        <Avatar
                            size={35}
                            className="flex flex-center background-200"
                            src={getAvatar(student) || user?.avatar}
                            icon={<FaUserGraduate size={15} className="text-color-500"/>}
                        />
                        <div className="flex flex-col gap-1">
                            <div className="flex items-baseline gap-1 leading-snug">
                                {renderIf(
                                    patron_saint_name,
                                    <span className="font-medium text-sm text-color-100 italic">
                          {getAliasName(student, 'patron_saint')}
                      </span>
                                )}
                                <span className="font-bold text-color-000 ">
                    {fullname}
                  </span>
                            </div>
                            {renderIf(
                                student_idcode,
                                <div className="space-x-1 text-color-500 text-2xs italic">
                      <span className="whitespace-no-wrap">
                        {isSm ? '#' : `${t('student code')} : `}
                      </span>
                                    <span
                                        onClick={() => {
                                            copyToClipboard(student_idcode)
                                            message.info(t('copied'))
                                        }}
                                        className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                        {student_idcode}
                                        <IoCopyOutline size={10} className="ml-1"/>
                      </span>
                                </div>
                            )}
                        </div>
                    </div>
                    {renderIf(
                        registered_classes?.length,
                        <div className="space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500 whitespace-no-wrap italic">
                    {`${t('students of class')} : `}
                  </span>
                            {registered_classes.map((e, i) => (
                                <Link key={i} to={getLinkToDetail(e)}
                                      className="font-semibold text-color-100 no-underline">
                                    {getTitle(e)} {i < registered_classes.length - 1 && ', '}
                                </Link>
                            ))}
                        </div>
                    )}
                    {renderIf(
                        registered_subjects?.length,
                        <div className="space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500 whitespace-no-wrap italic">
                    {`${t('subjects registered')} : `}
                  </span>
                            {registered_subjects.map((e, i) => (
                                <span className="font-semibold text-color-100">
                        {getTitle(e)} {i < registered_subjects.length - 1 && ', '}
                      </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <Tabs
                defaultActiveKey="0"
                onChange={setCurrent}
                size="small"
                tabBarStyle={{margin: '0 0 12px 0'}}
                items={[
                    {
                        key: '0',
                        label: t('subjects of course'),
                        className: 'space-y-3',
                        children: (
                            <EntityList
                                key={refreshKey}
                                apiInfo={apiInfo}
                                refreshKey={refreshKey}
                                RenderEntity={React.Fragment}
                                query={bindQueryParams([{student_id}, {course_id}])}
                                renderItem={renderCourseClassStudentSubjectSummary({
                                    renderActions,
                                    registered_subjects,
                                })}
                                renderEmpty={renderEmptyHolder}
                                renderWrap={(child, __, count) =>
                                    renderIf(
                                        count,
                                        <div className="w-full flex flex-col flex-1 gap-3">
                                            <div className="text-sm text-color-400 italic whitespace-nowrap">
                                                {`* ${t('results for each course of the program')} - ${registered_subjects.length}/${count}`}
                                            </div>
                                            <div className="flex flex-col gap-3">{child}</div>
                                        </div>
                                    )
                                }
                            />
                        ),
                    },
                    {
                        key: '1',
                        label: t('subjects complete'),
                        className: 'space-y-3',
                        children: (
                            <EntityList
                                key={refreshKey1}
                                apiInfo={apiInfo1}
                                refreshKey={refreshKey1}
                                values={{course_id}}
                                RenderEntity={React.Fragment}
                                renderItem={renderSubjectResultItem({})}
                                query={bindQueryParam({student_id})}
                                renderWrap={(child, __, count) =>
                                    renderIfElse(
                                        count > 0,
                                        <div className="w-full flex flex-col flex-1 gap-3">
                                            <div className="text-sm text-color-400 italic">
                                                {t('courses completed in the past')}
                                            </div>
                                            <div className="flex flex-col gap-3">{child}</div>
                                        </div>,
                                        renderEmptyHolderMember(
                                            'no data is available now',
                                            'subject complete description'
                                        )
                                    )
                                }
                            />
                        ),
                    },
                ]}
            />

            {modal}
        </div>
    )
}

export default CourseStudentSubjectResults
